import { DocumentList } from './DocumentList';
import { IconApps } from '../ui/icons';
export const documents = {
    icon: IconApps,
    list: DocumentList,
};
export * from './DocumentList';
export * from './DocumentTitle';
export * from './Documentation';
export * from './useMarkdownContent';
//# sourceMappingURL=index.js.map